import { LENGTH_DATE, LENGTH_MONTH, LENGTH_YEAR } from "../../../../lib/date/constants";
import { InternalDateComponentType } from "../../../../lib/date/types";
export var inputNumber = function inputNumber(type, prev, key, inputMode) {
  var nextInputMode = false;
  var nextValue;
  var first = 10;
  var length = LENGTH_YEAR;

  if (type === InternalDateComponentType.Month) {
    first = 1;
    length = LENGTH_MONTH;
  }

  if (type === InternalDateComponentType.Date) {
    first = 3;
    length = LENGTH_DATE;
  }

  if (!inputMode) {
    nextValue = key;
    nextInputMode = Number(key) <= first;
  } else {
    nextValue = ("" + (prev === null ? '' : prev) + key).slice(-length);
    nextInputMode = nextValue.length < length;
  }

  return {
    nextValue: nextValue,
    nextInputMode: nextInputMode
  };
};